import React from 'react';
import { ICreditCardExpiryDate } from '../../../domain/models';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

interface IFormattedExpiryDate {
	expiryDate: ICreditCardExpiryDate;
}

export const FormattedExpiryDate = ({ expiryDate }: IFormattedExpiryDate) => {
	const { t } = useTranslation();
	const { month, year } = expiryDate;

	return <div>{`${t('payment_card_expiry_label')}: ${month}/${year}`}</div>;
};
